import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { BreakdownItem } from '../../types';
import { formatNumber } from '../../constants/nginx-sites';

interface MiniBarTableProps {
  title: string;
  data: BreakdownItem[];
  color: string;
}

export function MiniBarTable({ title, data, color }: MiniBarTableProps) {
  if (data.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Nome</TableHead>
              <TableHead className="text-right">Visitantes</TableHead>
              <TableHead className="w-[100px]"></TableHead>
              <TableHead className="text-right">Porcentagem</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((item) => (
              <TableRow key={item.name}>
                <TableCell className="font-medium">{item.name}</TableCell>
                <TableCell className="text-right">
                  <div>{formatNumber(item.visitors ?? item.count)}</div>
                  {(item.visitors ?? 0) > 0 && (
                    <div className="text-xs text-muted-foreground">{formatNumber(item.count)} req</div>
                  )}
                </TableCell>
                <TableCell>
                  <div className="w-full bg-muted rounded-full h-2">
                    <div
                      className="h-2 rounded-full"
                      style={{
                        width: `${item.percentage ?? 0}%`,
                        backgroundColor: color,
                      }}
                    />
                  </div>
                </TableCell>
                <TableCell className="text-right">{(item.percentage ?? 0).toFixed(1)}%</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
